const obj = {
  _id: "68ff57f0844000338fb6295e",
  paraMeterWego: "bansalGtrip",
  softValueWego: "N",
  paraMeterSky: "customRoundTrip",
  softValueSky: "N",
  paraMeterGoogle: "customRoundTrip",
  softValueGoogle: "N",
  maxDataSizeMB: 1,
  outBoundAirlineSky: "AI",
  outBoundAirlineWego: "AI",
  outBoundAirlineGoogle: "AI",
  bookingDiscountCapIndia: 10,
  bookingDiscountCapRestOfIndia: 10,
};
export const updateFieldData = (data) => [
  {
    name: "paraMeterWego",
    label: "Wego Parameter",
    value: data.paraMeterWego,
    type: "text",
    placeHolder: "Enter Wego Parameter",
  },
  {
    name: "softValueWego",
    label: "Wego Soft Value",
    value: data.softValueWego,
    type: "text",
    placeHolder: "Enter Wego Soft Value",
  },
  {
    name: "outBoundAirlineWego",
    label: "Wego Outbound Airline",
    value: data.outBoundAirlineWego,
    type: "text",
    placeHolder: "Enter Wego Outbound Airline",
  },
  {
    name: "paraMeterSky",
    label: "Sky Parameter",
    value: data.paraMeterSky,
    type: "text",
    placeHolder: "Enter Sky Parameter",
  },
  {
    name: "softValueSky",
    label: "Sky Soft Value",
    value: data.softValueSky,
    type: "text",
    placeHolder: "Enter Sky Soft Value",
  },
  {
    name: "outBoundAirlineSky",
    label: "Sky Outbound Airline",
    value: data.outBoundAirlineSky,
    type: "text",
    placeHolder: "Enter Sky Outbound Airline",
  },
  {
    name: "paraMeterGoogle",
    label: "Google Parameter",
    value: data.paraMeterGoogle,
    type: "text",
    placeHolder: "Enter Google Parameter",
  },
  {
    name: "softValueGoogle",
    label: "Google Soft Value",
    value: data.softValueGoogle,
    type: "text",
    placeHolder: "Enter Google Soft Value",
  },
  {
    name: "outBoundAirlineGoogle",
    label: "Google Outbound Airline",
    value: data.outBoundAirlineGoogle,
    type: "text",
    placeHolder: "Enter Google Outbound Airline",
  },
  {
    name: "maxDataSizeMB",
    label: "Max Data Size",
    value: data.maxDataSizeMB,
    type: "number",
    placeHolder: "Enter Max Data Size",
  },
  {
    name: "bookingDiscountCapIndia",
    label: "Booking Discount Cap India",
    value: data.bookingDiscountCapIndia,
    type: "number",
    placeHolder: "Enter Booking Discount Cap India",
  },
  {
    name: "bookingDiscountCapRestOfIndia",
    label: "Booking Discount Cap Rest Of India",
    value: data.bookingDiscountCapRestOfIndia,
    type: "number",
    placeHolder: "Enter Booking Discount Cap Rest Of India",
  },
];
